module.exports = __webpack_public_path__ + "img/cow.cb3d3641.svg";